// extracted by css-extract-rspack-plugin
export default {"cls1":"RelatedPapers-cls1_bQq","cls2":"RelatedPapers-cls2_50Z RelatedPapers-cls1_bQq"};